import { createFileRoute } from '@tanstack/react-router'
import { SetPasswordPage } from '../features/auth/set-password-page'

/**
 * An invitation (`/set-password/:token`, R0b W11): outside the signed-in layout, so no session is
 * asked for. The token from the e-mail is the only key (GET/POST /auth/invitations/:token).
 */
export const Route = createFileRoute('/set-password/$token')({
  component: SetPasswordRoute,
})

function SetPasswordRoute() {
  const { token } = Route.useParams()
  return <SetPasswordPage token={token} />
}
